import { render } from "./Anchor.vue?vue&type=template&id=b648029e"
import script from "./Anchor.vue?vue&type=script&lang=js"
export * from "./Anchor.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Anchor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b648029e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b648029e', __exports__)) {
    api.reload('b648029e', __exports__)
  }
  
  module.hot.accept("./Anchor.vue?vue&type=template&id=b648029e", () => {
    api.rerender('b648029e', render)
  })

}


export default __exports__